import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IApplicationState } from '../../../Store';
import { 
    setUserChannels, 
    setUserChannelsSTT, 
    setUserChannelsTPP, 
    getChannelsFromUser, 
    getChannelsFromUserSTT, 
    getChannelsFromUserTPP,
    setGroupChannels,
    setGroupChannelsSTT,
    setGroupChannelsTPP,
    setGroupChannelsMT,
    getChannelsFromUserMT
} from '../../../Store/AppsManagement/Actions';

interface IProps {
    open: boolean;
    onClose: () => void;
    targetId: number;
    token: string;
    isGroup?: boolean;  // Optionnel avec false par défaut
}

interface IState {
    selectedApp: string;
    addChannels: string;
    deleteChannels: string;
    showConfirmation: boolean;
}

interface IDispatchProps {
    setUserChannels: (channelsID: number[], id: number) => void;
    setUserChannelsSTT: (channelsID: number[], id: number) => void;
    setUserChannelsTPP: (channelsID: number[], id: number) => void;
    setGroupChannels: (channelsID: number[], id: number) => void;
    setGroupChannelsSTT: (channelsID: number[], id: number) => void;
    setGroupChannelsTPP: (channelsID: number[], id: number) => void;
    setGroupChannelsMT: (addedIDs: any[], removedIDs: any[], updatedIDs: any[], id: number, token: string) => void;
    getChannelsFromUser: (userId: number, isGroup: boolean) => void;
    getChannelsFromUserSTT: (userId: number, isGroup: boolean) => void;
    getChannelsFromUserTPP: (userId: number, isGroup: boolean) => void;
    getChannelsFromUserMT: (userId: number, token: string) => void;
}

interface IStateProps {
    loading: boolean;
    loadingChannels: boolean;
    error: string | null;
    success?: boolean;
    userChannels: { id: number; name: string; }[];
}

type AllProps = IProps & IStateProps & IDispatchProps;

class ChannelsPopupComponent extends React.Component<AllProps, IState> {
    static defaultProps = {
        isGroup: false
    };

    constructor(props: AllProps) {
        super(props);
        this.state = this.getInitialState();
    }

    componentDidUpdate(prevProps: AllProps, prevState: IState) {
        if (!prevProps.open && this.props.open) {
            this.setState({
                ...this.getInitialState(),
                selectedApp: this.state.selectedApp
            });
            this.loadChannels();
        }
        
    }

    private getInitialState = () => ({
        selectedApp: 'mediaarchiver-global',
        addChannels: '',
        deleteChannels: '',
        showConfirmation: false
    });

    private handleSubmit = () => {
        this.setState({ showConfirmation: true });
    };

    private parseChannelArrays() {
        const addChannelsArray = this.state.addChannels
            .split(',')
            .map(id => parseInt(id.trim(), 10))
            .filter(id => !isNaN(id));

        const deleteChannelsArray = this.state.deleteChannels
            .split(',')
            .map(id => parseInt(id.trim(), 10))
            .filter(id => !isNaN(id));

        const existingIds = this.props.userChannels.map(channel => channel.id);
        const finalChannels = [
            ...existingIds.filter(id => !deleteChannelsArray.includes(id)),
            ...addChannelsArray
        ];

        return {
            addChannelsArray,
            deleteChannelsArray,
            existingIds,
            finalChannels
        };
    }

    private handleConfirm = () => {
        const { addChannelsArray, deleteChannelsArray, finalChannels } = this.parseChannelArrays();
        const { targetId, isGroup } = this.props;

        switch (this.state.selectedApp) {
            case 'mediaarchiver-global':
                isGroup 
                    ? this.props.setGroupChannels(finalChannels, targetId)
                    : this.props.setUserChannels(finalChannels, targetId);
                break;
            case 'mediaarchiver-stt':
                isGroup
                    ? this.props.setGroupChannelsSTT(finalChannels, targetId)
                    : this.props.setUserChannelsSTT(finalChannels, targetId);
                break;
            case 'mediaarchiver-tpp':
                isGroup
                    ? this.props.setGroupChannelsTPP(finalChannels, targetId)
                    : this.props.setUserChannelsTPP(finalChannels, targetId);
                break;
            case 'mytrack':
                if (isGroup) {
                    const startDate = `${new Date().getFullYear()}-01-01T00:00:00`;
                    const channelsWithDates = {
                        addedIDs: addChannelsArray.map(id => ({
                            mediaID: id,
                            startDate,
                            endDate: ''
                        })),
                        removedIDs: deleteChannelsArray.map(id => ({
                            mediaID: id,
                            startDate: '',
                            endDate: ''
                        })),
                        updatedIDs: []
                    };
                    this.props.setGroupChannelsMT(
                        channelsWithDates.addedIDs,
                        channelsWithDates.removedIDs,
                        channelsWithDates.updatedIDs,
                        targetId,
                        this.props.token
                    );
                }
                break;
        }

        this.setState({ showConfirmation: false });
        this.props.onClose();
    };

    private getChannelsList() {
        const { addChannelsArray, deleteChannelsArray, existingIds } = this.parseChannelArrays();
        const channelsById = this.props.userChannels.reduce((acc, channel) => {
            acc[channel.id] = channel.name;
            return acc;
        }, {} as { [key: number]: string });

        return [
            ...addChannelsArray.map(id => ({
                id,
                name: channelsById[id] || '-',
                status: 'add' as const
            })),
            ...deleteChannelsArray.map(id => ({
                id,
                name: channelsById[id] || '-',
                status: 'remove' as const
            })),
            ...existingIds
                .filter(id => !addChannelsArray.includes(id) && !deleteChannelsArray.includes(id))
                .map(id => ({
                    id,
                    name: channelsById[id] || '-',
                    status: 'existing' as const
                }))
        ];
    }

    private renderConfirmationDialog() {
        const channelsList = this.getChannelsList();

        return (
            <MD.Dialog
                open={this.state.showConfirmation}
                onClose={() => this.setState({ showConfirmation: false })}
                maxWidth="md"
                fullWidth
            >
                <MD.DialogTitle>
                    Confirm Channel Changes - {this.state.selectedApp}
                </MD.DialogTitle>
                <MD.DialogContent>
                    <MD.TableContainer>
                        <MD.Table size="small">
                            <MD.TableHead>
                                <MD.TableRow>
                                    <MD.TableCell></MD.TableCell>
                                    <MD.TableCell>Channel ID</MD.TableCell>
                                    <MD.TableCell>Name</MD.TableCell>
                                </MD.TableRow>
                            </MD.TableHead>
                            <MD.TableBody>
                                {channelsList.map((channel) => (
                                    <MD.TableRow
                                        key={channel.id}
                                        style={{
                                            backgroundColor: channel.status === 'add' 
                                                ? 'rgba(76, 175, 80, 0.1)'
                                                : channel.status === 'remove'
                                                    ? 'rgba(244, 67, 54, 0.1)'
                                                    : 'inherit'
                                        }}
                                    >
                                        <MD.TableCell>
                                            {channel.status === 'add' && (
                                                <MD.Box color="success.main">
                                                    <span style={{ fontSize: '18px' }}>+</span>
                                                </MD.Box>
                                            )}
                                            {channel.status === 'remove' && (
                                                <MD.Box color="error.main">
                                                    <span style={{ fontSize: '18px' }}>-</span>
                                                </MD.Box>
                                            )}
                                        </MD.TableCell>
                                        <MD.TableCell>{channel.id}</MD.TableCell>
                                        <MD.TableCell>{channel.name || '-'}</MD.TableCell>
                                    </MD.TableRow>
                                ))}
                            </MD.TableBody>
                        </MD.Table>
                    </MD.TableContainer>
                </MD.DialogContent>
                <MD.DialogActions>
                    <MD.Button 
                        onClick={() => this.setState({ showConfirmation: false })}
                    >
                        Cancel
                    </MD.Button>
                    <MD.Button 
                        onClick={this.handleConfirm}
                        color="primary" 
                        variant="contained"
                    >
                        Confirm Changes
                    </MD.Button>
                </MD.DialogActions>
            </MD.Dialog>
        );
    }

    private loadChannels = () => {
        const { targetId, isGroup = false } = this.props;
        
        switch (this.state.selectedApp) {
            case 'mediaarchiver-global':
                this.props.getChannelsFromUser(targetId, isGroup);
                break;
            case 'mediaarchiver-stt':
                this.props.getChannelsFromUserSTT(targetId, isGroup);
                break;
            case 'mediaarchiver-tpp':
                this.props.getChannelsFromUserTPP(targetId, isGroup);
                break;
            case 'mytrack':
                if (isGroup) {
                    this.props.getChannelsFromUserMT(targetId, this.props.token);
                }
                break;
        }
    }

    public render(): React.ReactNode {
        const { loadingChannels } = this.props;
        
        return (
            <>
                <MD.Dialog 
                    open={this.props.open} 
                    onClose={this.props.onClose}
                    BackdropProps={{
                        style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
                    }}
                    PaperProps={{
                        style: {
                            width: '500px',
                            maxWidth: '500px',
                            height: 'auto',
                            maxHeight: '80vh'
                        }
                    }}
                    maxWidth={false}
                    fullWidth={false}
                >
                    <MD.DialogTitle>Manage User Channels</MD.DialogTitle>
                    <MD.DialogContent style={{ overflow: 'visible', minHeight: '200px' }}>
                        <MD.FormControl fullWidth margin="normal">
                            <MD.InputLabel>Application Type</MD.InputLabel>
                            <MD.Select
                                value={this.state.selectedApp}
                                onChange={(e) => {
                                    this.setState({
                                        selectedApp: e.target.value as string,
                                        addChannels: '',
                                        deleteChannels: '',
                                        showConfirmation: false
                                    }, () => {
                                        this.loadChannels();
                                    });
                                }}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    },
                                    getContentAnchorEl: null
                                }}
                            >
                                <MD.MenuItem value="mediaarchiver-global">Mediaarchiver - Global</MD.MenuItem>
                                <MD.MenuItem value="mediaarchiver-tpp">Mediaarchiver - TPP</MD.MenuItem>
                                <MD.MenuItem value="mediaarchiver-stt">Mediaarchiver - STT</MD.MenuItem>
                                {this.props.isGroup && (
                                    <MD.MenuItem value="mytrack">MyTrack</MD.MenuItem>
                                )}
                            </MD.Select>
                        </MD.FormControl>
                        
                        {loadingChannels ? (
                            <MD.Box 
                                display="flex" 
                                justifyContent="center" 
                                alignItems="center" 
                                minHeight="150px"
                            >
                                <MD.CircularProgress />
                            </MD.Box>
                        ) : (
                            <>
                                <MD.TextField
                                    fullWidth
                                    margin="normal"
                                    label="Add Channels (comma-separated IDs)"
                                    value={this.state.addChannels}
                                    onChange={(e) => this.setState({ addChannels: e.target.value })}
                                    placeholder="1,2,3,4"
                                />
                                
                                <MD.TextField
                                    fullWidth
                                    margin="normal"
                                    label="Delete Channels (comma-separated IDs)"
                                    value={this.state.deleteChannels}
                                    onChange={(e) => this.setState({ deleteChannels: e.target.value })}
                                    placeholder="5,6,7,8"
                                />
                            </>
                        )}
                    </MD.DialogContent>
                    <MD.DialogActions>
                        <MD.Button onClick={this.props.onClose} color="primary">
                            Cancel
                        </MD.Button>
                        <MD.Button 
                            onClick={this.handleSubmit} 
                            color="primary" 
                            variant="contained"
                            disabled={this.props.loading}
                        >
                            Submit
                        </MD.Button>
                    </MD.DialogActions>
                </MD.Dialog>
                {this.renderConfirmationDialog()}
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
    loading: state.appsManagement.loading,
    loadingChannels: state.appsManagement.loadingUserChannels,
    error: state.appsManagement.error,
    success: state.appsManagement.success,
    userChannels: (state.appsManagement.userChannels || []).map(channel => ({
        id: channel.id,
        name: channel.name || channel.mediaSource || String(channel.id)
    }))
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    setUserChannels: (channelsID: number[], id: number) =>
        dispatch(setUserChannels(channelsID, id)),
    setUserChannelsSTT: (channelsID: number[], id: number) =>
        dispatch(setUserChannelsSTT(channelsID, id)),
    setUserChannelsTPP: (channelsID: number[], id: number) =>
        dispatch(setUserChannelsTPP(channelsID, id)),
    getChannelsFromUser: (userId: number, isGroup: boolean) =>
        dispatch(getChannelsFromUser(userId, isGroup)),
    getChannelsFromUserSTT: (userId: number, isGroup: boolean) =>
        dispatch(getChannelsFromUserSTT(userId, isGroup)),
    getChannelsFromUserTPP: (userId: number, isGroup: boolean) =>
        dispatch(getChannelsFromUserTPP(userId, isGroup)),
    setGroupChannels: (channelsID: number[], id: number) =>
        dispatch(setGroupChannels(channelsID, id)),
    setGroupChannelsSTT: (channelsID: number[], id: number) =>
        dispatch(setGroupChannelsSTT(channelsID, id)),
    setGroupChannelsTPP: (channelsID: number[], id: number) =>
        dispatch(setGroupChannelsTPP(channelsID, id)),
    setGroupChannelsMT: (addedIDs: any[], removedIDs: any[], updatedIDs: any[], id: number, token: string) =>
        dispatch(setGroupChannelsMT(addedIDs, removedIDs, updatedIDs, id, token)),
    getChannelsFromUserMT: (userId: number, token: string) =>
        dispatch(getChannelsFromUserMT(userId, token))
});

export const ChannelsPopup = connect(
    mapStateToProps,
    mapDispatchToProps
)(ChannelsPopupComponent) as unknown as React.ComponentType<IProps>;
